export default __webpack_public_path__ + "static/media/spinner.cfa5f266.gif";